<template>
  <div class="wrap-page">
    <div class="page">
      <div class="title text-center">
        <h5 class="mb-0"><b>CERTIFICATE OF TIN DEPOSIT</b></h5>
        <h6 class="mb-0 bhs-indo"><i>BUKTI SIMPAN TIMAH (BST)</i></h6>
        <small>No. Reg : </small>
      </div>
      <div class="content">
        <div class="content-detail">
          <div class="content-title">
            <div>THIS IS TO CERTIFY, THAT EFFECTIVE FROM THE DATE OF ISSUEANCE STATED THERE IN BELOW, PT. BGR LOGISTIK INDONESIA CLAIM TO HAS RECEIVED TIN FROM</div>
            <small class="bhs-indo"><i>TERHITUNG SEJAK TANGGAL PENERBITAN TERSEBUT DIBAWAH, TELAH MENERIMA TIMAH DARI</i></small>
          </div>
          <tr>
            <td>
              <div>DEPOSITOR</div>
              <small class="bhs-indo"><i>PERUSAHAAN</i></small>
            </td>
            <td>:</td>
            <td></td>
          </tr>
          <tr>
            <td>
              <div>PIC/POSITION</div>
              <small class="bhs-indo"><i>PENANGGUNG JAWAB/JABATAN</i></small>
            </td>
            <td>:</td>
            <td></td>
          </tr>
          <tr>
            <td>
              <div>BRAND</div>
              <small class="bhs-indo"><i>MERK</i></small>
            </td>
            <td>:</td>
            <td></td>
          </tr>
          <tr>
            <td>
              <div>REGISTERED TIN EXPORTER NO.</div>
              <small class="bhs-indo"><i>NOMOR EKSPORTIR TIMAH TERDAFTAR</i></small>
            </td>
            <td>:</td>
            <td></td>
          </tr>
          <tr>
            <td>
              <div>TRADE ACCOUNT NUMBER</div>
              <small class="bhs-indo"><i>NOMOR ANGGOTA PEDAGANG</i></small>
            </td>
            <td>:</td>
            <td></td>
          </tr>
        </div>
        <div class="content-detail">
          <tr>
            <td>
              <div>WAREHOUSE LOCATION</div>
              <small class="bhs-indo"><i>LOKASI GUDANG</i></small>
            </td>
            <td>:</td>
            <td></td>
          </tr>
        </div>
        <div class="content-detail">
          <tr>
            <td>
              <div>BATCH NUMBER</div>
              <small class="bhs-indo"><i>NOMOR BATCH</i></small>
            </td>
            <td>:</td>
            <td></td>
          </tr>
        </div>
        <div class="wrap-detail d-flex">
          <div>
            <div class="content-detail">
              <tr>
                <td>
                  <div>QUANTITY</div>
                  <small class="bhs-indo"><i>KUANTITAS</i></small>
                </td>
                <td>:</td>
                <td>KG</td>
              </tr>
            </div>
            <div class="content-detail">
              <table class="table table-bordered">
                <thead>
                  <th>
                    <div>NO</div>
                    <small><i>NO</i></small>
                  </th>
                  <th>
                    <div>BUNDLE CODE</div>
                    <small><i>KODE BUNDLE</i></small>
                  </th>
                  <th>
                    <div>WEIGHT</div>
                    <small><i>BERAT (Kga)</i></small>
                  </th>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>B1</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>B2</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>B3</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>B4</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>B5</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>TOTAL</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div>
            <div class="content-detail">
              <tr>
                <td>
                  <div>LEVEL OF PURITY(Sn)</div>
                  <small class="bhs-indo"><i>TINGKAT KEMURNIAN</i></small>
                </td>
                <td>:</td>
                <td>%</td>
              </tr>
            </div>
            <div class="content-detail">
              <tr>
                <td>
                  <div>COA NO.</div>
                  <small class="bhs-indo"><i>NOMOR SERTIFIKAT ANALISIS</i></small>
                </td>
                <td>:</td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <div>ISSUED BY</div>
                  <small class="bhs-indo"><i>DITERBITKAN OLEH</i></small>
                </td>
                <td>:</td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <div>CONTRACT CODE</div>
                  <small class="bhs-indo"><i>KODE KONTRAK</i></small>
                </td>
                <td>:</td>
                <td></td>
              </tr>
            </div>
          </div>
        </div>

        <div class="content-disclaimer">
          <div>
            THIS CERTIFICATE IS A PROOF OF TIN DEPOSIT WHICH TRADED ACCORDING WITH JFX REGULATION. THE OWNERSHIP OF THIS CERTIFICATE OF TIN DEPOSIT WILL BE
            TRANSFERRED BASED ON THE RECEIPT OF TIN PURCHASE FROM EXCHANGE. LAS OWNER OF THIS CERTIFICATE AND DELIVERY OF COMMODITY SHALL BASED ON THE RECEIPT OF TIN
            PURCHASE FROM EXCHANGE AND RELASE INSTRUCTION FROM CLEARING HOUSE.
          </div>
          <div class="bhs-indo">
            <i
              >Sertifikat ini sebagai bukti simpan timah yang dapat diperdagangkan sesuai dengan aturan yang ditetapkan oleh Bursa Berjangka Indonesia. Bukti Simpan
              Timah ini akan berpindah kepemilikan berdasarkan Bukti Pembelian Timah dari Bursa (BPTP). Pemilik Terakhir dari sertifikat ini dan pengeluaran harus
              berdasarkan Bukti Pembelian Timah dari Bursa (BPTP) yang dikeluarkan oleh BBJ dan instruksi Pengeluaran Barang dari KBI</i
            >
          </div>
          <div>WAREHOUSE FEE 21 DAYS AFTER TIN SOLD WILL BE BEARED BY SELLER</div>
          <div class="bhs-indo">
            <i>Biaya jasa penyimpanan selama 21 hari setelah timah terjual akan ditanggung oleh penjual</i>
          </div>
          <div>
            PT. BGR LOGISTIK INDONESIA SHALL NOT BE RESPONIBLE FOR ALL THE CHANGES OF QUALITY, THE DEMAGE AND THE DISCREPANCES OF THE WEIGHT OF THE GOODS WHICS ARE
            BEING STORED AND DELIVERED FORM/TO WAREHOUSE DUE TO ITS OWN DEFAULT ERRORS. EXCEPT DELIBERATE ACT. GROSS NEGLIGENCE OMISSION/WILLFUL MISS CONDUCT BY
            BGR's OFFICER
          </div>
          <div class="bhs-indo">
            <i
              >PT. BGR LOGISTIK INDONESIA tidak bertanggung jawab terhadap segala bentuk penurunan kualitas dan atau kerusakan dan atau penyusutan berat barang yang
              disimpan dan dikirim dari/ke gudang yang disebabkan oleh sifat alamiah barang tersebut, kecuali perubahan mutu barang karena kelalaian, kesalahan yang
              disengaja/tidak disengaja oleh petugas BGR</i
            >
          </div>
        </div>
        <div class="content-close">
          <div>Pangkal Pinang, December 12, 2022</div>
          <div><b>PT. BGR LOGISTIK INDONESIA</b></div>
          <div>DIVRE V PANGKAL PINANG</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
@page {
  margin: 0;
  size: A4 landscape;
}
/* .wrap-page {
  background: white;
  width: 21cm;
  height: 29.7cm;
  display: block;
  margin: 0 auto;
  padding: 10px 25px;
  margin-bottom: 0.5cm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
  box-sizing: border-box;
  font-size: 10pt;
} */
.wrap-page {
  width: 210mm;
  min-height: 295mm;
  padding: 10mm;
  margin: 0 auto;
  /* border: 1px #D3D3D3 solid; */
  border-radius: 5px;
  background: white;
  position: relative;
  font-size: 10pt;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
}

.page {
  padding: 1cm;
  /* border: 5px red solid; */
  height: 257mm;
  /* outline: 2cm #FFFFFF solid; */
}

.table {
  margin-bottom: unset;
}

.bhs-indo {
  color: blue;
}

.content-title {
  line-height: 130%;
}

.content-detail {
  border: solid 1px #1a1a1a;
  padding: 0.1rem 0.5rem;
}

.wrap-detail {
  display: flex;
}

.wrap-detail div {
  flex: 1 1;
}

table th,
table td {
  padding: unset;
  line-height: 120%;
}

table td {
  font-size: 12px;
}

.content-disclaimer {
  font-size: 9pt;
}

.content-close {
  text-align: center;
  line-height: 130%;
  margin-top: 1rem;
}

td div {
  line-height: 50%;
}
</style>
